import { Box, BoxProps } from '@mantine/core';
import type { WizardActions, WizardStepData } from './types';
import { IconPropsType } from '../../icons/types';
import { CheckCircleIcon } from '../../icons';
import { WizardSidebarStep } from './WizardSidebarStep';

export type WizardStepsProps = BoxProps &
  Pick<WizardActions, 'goToStep'> & {
    steps: WizardStepData[];
    iconProps?: IconPropsType;
    hideVirtualLastStep?: boolean;
    currentStepIndex?: number;
    doneStepsIndex?: number[];
    availableStepsIndex?: number[];
  };

/**
 * WizardSidebarSteps component
 * @private
 */
export const WizardSidebarSteps: React.FC<WizardStepsProps> = ({
  steps = [],
  hideVirtualLastStep,
  goToStep,
  doneStepsIndex,
  availableStepsIndex,
  currentStepIndex,
  sx,
  ...boxProps
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      ...sx,
    }}
    {...boxProps}
  >
    {steps.map((step, index) => (
      <WizardSidebarStep
        key={`${step.label}`}
        data={step}
        isDone={doneStepsIndex?.includes(index)}
        isActive={currentStepIndex === index}
        disabled={!availableStepsIndex?.includes(index)}
        onClick={() => goToStep(index)}
      />
    ))}
    {hideVirtualLastStep ? null : (
      <WizardSidebarStep
        disabled
        key="VirtualLastStep"
        iconProps={{ size: 18 }}
        data={{
          label: 'common:ready',
          icon: CheckCircleIcon,
          content: Box,
        }}
      />
    )}
  </Box>
);
